import gsap from 'gsap'
import Swiper, { Navigation } from 'swiper'

class HowItWorks {
  constructor() {
    if (document.querySelector('.howItWorks')) {
      this.HowItWorks()
    }
  }

  HowItWorks() {
    document.querySelectorAll('.toggleIcon').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const answerDom = document.getElementById(toggle.dataset.faqId)

        if (answerDom.classList.contains('show')) {
          answerDom.classList.remove('show')
        } else {
          answerDom.classList.add('show')
        }
      })
    })
  }
}

export default HowItWorks
